/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
export default class RotateCommand {
  /**
   * Constructor
   */
  constructor(target, angle) {
    this.label = 'Rotation'
    this.target = target
    this.angle = angle
  }

  execute() {
    this.angle += this.target.canvas.getActiveObject().angle
    this.target.canvas.getActiveObject().rotate(this.angle)
  }

  undo() {
    this.angle = this.target.canvas.getActiveObject().angle - this.angle
    this.target.canvas.getActiveObject().rotate(this.angle)
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/RotateCommand.js